import { Deserializable } from '../deserializable';
import { UserTradingStatistics } from '../users/userTradingStatistics';
export class TransactionDataBundle implements Deserializable {

    public totalTradeProfit: number;
    public averageTradeProfit: number;
    public averageProfitPercentage: number;
    public noOfTrades: number;
    public fromDate: Date;
    public toDate: Date;

    public tradingStatistics: UserTradingStatistics;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
